// ============================================
// Leka — Entry Point
// ============================================
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { registerSW } from 'virtual:pwa-register'
import '@/styles/globals.css'
import { App } from './App'
import { initSentry } from '@/shared/lib/sentry'

initSentry()

if (typeof window !== 'undefined' && import.meta.env.PROD && window.location.hostname === 'tryleka.com') {
  registerSW({
    immediate: false,
    onRegisterError(error) {
      console.warn('[PWA] service worker registration failed', error)
    },
  })
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
